import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { Atencion } from 'src/core/atencion/atencion.types';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';
import { RazaService } from 'src/core/raza/raza.service';
import { Raza } from 'src/core/raza/raza.types';
import { TallaService } from 'src/core/talla/talla.service';
import { Talla } from 'src/core/talla/talla.types';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';
import { VeterinariaService } from 'src/core/veterinaria/veterianaria.service';
import { Veterinaria } from 'src/core/veterinaria/veterinaria.types';

//const userSession = JSON.parse(localStorage.getItem('userSession')) as User;

export const tallasResolver: ResolveFn<Talla[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      return inject(TallaService).getTallas();
};

export const razaResolver: ResolveFn<Raza[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      return inject(RazaService).getRazas();
};

export const consultasUserVetResolver: ResolveFn<Consulta[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      const _userService = inject(UserService);
      const _consultaService = inject(ConsultaService);

      return _userService.user_session$.pipe(
        switchMap((userSession: User) => {
          return _consultaService.getConsultasByUsuarioVet(userSession.idVeterinaria);
        })
      );
};

export const consultasUserClientResolver: ResolveFn<Consulta[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      const _userService = inject(UserService);
      const _consultaService = inject(ConsultaService);

      return _userService.user_session$.pipe(
        switchMap((userSession: User) => {
          return _consultaService.getConsultasByUsuarioClient(userSession.id);
        })
      );
};

export const veterinariasResolver: ResolveFn<Veterinaria[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      return inject(VeterinariaService).getVeterinarias();
};

export const atencionesResolver: ResolveFn<Atencion[]> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      return inject(AtencionService).getAtenciones();
};
